import React from "react";
import {ValidateStep4Data} from "@validators/business-insurance-form/step4-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";
import {
   BUSINESS_PREMISE_LOCATION_OPTIONS, PREMISE_FLOORING_TYPE_OPTIONS, PREMISE_OCCUPATION_TIME_OPTIONS,
   PREMISE_ROOFING_TYPE_OPTIONS, PREMISE_WALL_TYPE_OPTIONS
} from "@constants/form-optins/business-insurance-options";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import {YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";


export default function IF_Step3(
    {
        data,
        handlers,
        setCurrentStep,
        handlePolicyHolderAccidentPropChange,
        handlePolicyHolderConvictionPropChange,
        addPolicyHolderAccident,
        addPolicyHolderConviction,
        removePolicyHolderAccident,
        removePolicyHolderConviction,
    }
) {

    const STEP = 4;

    const onPrevBtnClick = (event) => {

        setCurrentStep(STEP - 1);

    }

    function onNextBtnClick() {

        let validationResult = ValidateStep4Data(data);

        if (validationResult.length) {

            showValidationErrorsModal({
                validationResult: validationResult
            });


        } else {
            setCurrentStep(STEP + 1);
        }


    }


    return (
        <div className={`if-step-${STEP}`}>

            {/*
                Claims and convictions ...
            */}

            <SectionHeading
                text="Premises"
            />
           
           <div className="row">
              
              {/* Where is your premises located? */}
              
              <ScrollableDropdownBlock
                 selectedValues={data.businessPremiseLocation}
                 controlName="businessPremiseLocation"
                 containerCssClass="col-12 py-3"
                 labelText="Where is your premises located?"
                 required={true}
                 options={BUSINESS_PREMISE_LOCATION_OPTIONS}
                 
                 onChange={handlers.onControlChange}
                 helpText=""
              />
              
              {/* What are the opening hours for your business? */}
              
              <ScrollableTextBoxBlock
                 value={data.businessOpeningHours}
                 containerCssClass="col-12 py-3"
                 labelText="What are the opening hours for your business?"
                 required={true}
                 controlName="businessOpeningHours"
                 
                 onChange={handlers.onControlChange}
                 asTextArea={false}
                 inputAttrs={{
                    maxLength: 100
                 }}
              />
              
              {/* Any CCTV camera inside this premise? */}
              
              <ScrollableButtonGroupBlock
                 selectedValues={data.hasCcTvCameraInsidePremise}
                 containerCssClass="col-12 py-3"
                 labelText="Any CCTV camera inside this premise?"
                 required={true}
                 controlName="hasCcTvCameraInsidePremise"
                 options={YES_NO_CHOICE_OPTIONS}
                 
                 onChange={handlers.onControlChange}
              />
              
              {/* Is this premise entitled as a listed building? */}
              
              <ScrollableButtonGroupBlock
                 selectedValues={data.isThePremiseEntitledAsListedBuilding}
                 containerCssClass="col-12 py-3"
                 labelText="Is this premise entitled as a listed building?"
                 required={true}
                 controlName="isThePremiseEntitledAsListedBuilding"
                 options={YES_NO_CHOICE_OPTIONS}
                 
                 onChange={handlers.onControlChange}
              />
              
              {/* The roof of this premise */}
              
              <ScrollableDropdownBlock
                 selectedValues={data.premiseRoofType}
                 controlName="premiseRoofType"
                 containerCssClass="col-12 py-3"
                 labelText="The roof of this premises"
                 required={true}
                 options={PREMISE_ROOFING_TYPE_OPTIONS}
                 
                 onChange={handlers.onControlChange}
                 helpText=""
              />
              
              {/* The floor of the premise */}
              
              <ScrollableDropdownBlock
                 selectedValues={data.premiseFlooringType}
                 controlName="premiseFlooringType"
                 containerCssClass="col-12 py-3"
                 labelText="The floor of the premise"
                 required={true}
                 options={PREMISE_FLOORING_TYPE_OPTIONS}
                 
                 onChange={handlers.onControlChange}
                 helpText=""
              />
              
              {/* The walls, are they made of bricks or wood */}
              
              <ScrollableDropdownBlock
                 selectedValues={data.premiseWallType}
                 controlName="premiseWallType"
                 containerCssClass="col-12 py-3"
                 labelText="Premise wall type"
                 required={true}
                 options={PREMISE_WALL_TYPE_OPTIONS}
                 
                 onChange={handlers.onControlChange}
                 helpText=""
              />
              
              {/* Does anyone live upstairs? */}
              
              <ScrollableButtonGroupBlock
                 selectedValues={data.doesAnyoneLiveUpStairs}
                 containerCssClass="col-12 py-3"
                 labelText="Does anyone live upstairs?"
                 required={true}
                 controlName="doesAnyoneLiveUpStairs"
                 options={YES_NO_CHOICE_OPTIONS}
                 
                 onChange={handlers.onControlChange}
              />
              
              {"Yes" === data.doesAnyoneLiveUpStairs && (
                 <>
                    {/* who live upstairs? */}
                    
                    <ScrollableTextBoxBlock
                       value={data.whoLivesUpStairs}
                       containerCssClass="col-12 py-3"
                       labelText="who live upstairs?"
                       required={"Yes" === data.doesAnyoneLiveUpStairs}
                       controlName="whoLivesUpStairs"
                       
                       onChange={handlers.onControlChange}
                       asTextArea={false}
                       inputAttrs={{
                          maxLength: 50
                       }}
                    />
                 </>
              )}
              
              {/* The back door, is it secured enough with any shutters or grilled? */}
              
              <ScrollableButtonGroupBlock
                 selectedValues={data.isBackDoorSecured}
                 containerCssClass="col-12 py-3"
                 labelText="The back door, is it secured enough with any shutters or grilled?"
                 required={true}
                 controlName="isBackDoorSecured"
                 options={YES_NO_CHOICE_OPTIONS}
                 
                 onChange={handlers.onControlChange}
              />
              
              {/* When is the premise occupied? */}
              
              <ScrollableDropdownBlock
                 selectedValues={data.premiseOccupationTime}
                 controlName="premiseOccupationTime"
                 containerCssClass="col-12 py-3"
                 labelText="When is the premise occupied?"
                 required={true}
                 options={PREMISE_OCCUPATION_TIME_OPTIONS}
                 
                 onChange={handlers.onControlChange}
                 helpText=""
              />
              
              {/* Does the property have a roller shutter which covers all ground floor exposed glazing? */}
              
              <ScrollableButtonGroupBlock
                 selectedValues={data.hasRollerShuttersOnPremise}
                 containerCssClass="col-12 py-3"
                 labelText="Does the property have a roller shutter which covers all ground floor exposed glazing?"
                 required={true}
                 controlName="hasRollerShuttersOnPremise"
                 options={YES_NO_CHOICE_OPTIONS}
                 
                 onChange={handlers.onControlChange}
              />
              
              {/* Does the property have any grilles fitted at the back which cover all ground floor exposed glazing? */}
              
              <ScrollableButtonGroupBlock
                 selectedValues={data.hasGrillsOnPremise}
                 containerCssClass="col-12 py-3"
                 labelText="Does the property have any grilles fitted at the back which cover all ground floor exposed glazing?"
                 required={true}
                 controlName="hasGrillsOnPremise"
                 options={YES_NO_CHOICE_OPTIONS}
                 
                 onChange={handlers.onControlChange}
              />
              
              {/* Do you have any sort of alarm in the premises? */}
              
              <ScrollableButtonGroupBlock
                 selectedValues={data.hasAlarmsOnPremise}
                 containerCssClass="col-12 py-3"
                 labelText="Do you have any sort of alarm in the premises?"
                 required={true}
                 controlName="hasAlarmsOnPremise"
                 options={YES_NO_CHOICE_OPTIONS}
                 
                 onChange={handlers.onControlChange}
              />
              
              {"Yes" === data.hasAlarmsOnPremise && (
                 <div className="row hidden-box">
                    
                    {/* Name/brand of the alarm */}
                    
                    <ScrollableTextBoxBlock
                       value={data.premiseAlarmDetails}
                       containerCssClass="col-12 py-3"
                       labelText="Name/brand of the alarm"
                       required={"Yes" === data.hasAlarmsOnPremise}
                       controlName="premiseAlarmDetails"
                       
                       onChange={handlers.onControlChange}
                       asTextArea={false}
                       inputAttrs={{
                          maxLength: 100
                       }}
                    />
                    
                    {/* Does the alarm notify the police alongside you? */}
                    
                    <ScrollableButtonGroupBlock
                       selectedValues={data.doesAlarmNotifyPolice}
                       containerCssClass="col-12 py-3"
                       labelText="Does the alarm notify the police alongside you?"
                       required={"Yes" === data.hasAlarmsOnPremise}
                       controlName="doesAlarmNotifyPolice"
                       options={YES_NO_CHOICE_OPTIONS}
                       
                       onChange={handlers.onControlChange}
                    />
                    
                    {/* Is the alarm being monitored regularly by an organisation? */}
                    
                    <ScrollableButtonGroupBlock
                       selectedValues={data.isPremiseAlarmCheckedRegularly}
                       containerCssClass="col-12 py-3"
                       labelText="Is the alarm being monitored regularly by an organisation?"
                       required={"Yes" === data.hasAlarmsOnPremise}
                       controlName="isPremiseAlarmCheckedRegularly"
                       options={YES_NO_CHOICE_OPTIONS}
                       
                       onChange={handlers.onControlChange}
                    />
                    
                    
                    
                 </div>
              )}
              
              {/* Do you have use of kitchen in the premises for commercial use? */}
              
              <ScrollableButtonGroupBlock
                 selectedValues={data.hasCommercialKitchenOnPremise}
                 containerCssClass="col-12 py-3"
                 labelText="Do you have use of kitchen in the premises for commercial use?"
                 required={true}
                 controlName="hasCommercialKitchenOnPremise"
                 options={YES_NO_CHOICE_OPTIONS}
                 
                 onChange={handlers.onControlChange}
              />
              
              {/* Are you running a Café, or Take away restaurant? */}
              
              <ScrollableButtonGroupBlock
                 selectedValues={data.isRunningACaffeOrTakeAwayRestaurant}
                 containerCssClass="col-12 py-3"
                 labelText="Are you running a Café, or Take away restaurant?"
                 required={true}
                 controlName="isRunningACaffeOrTakeAwayRestaurant"
                 options={YES_NO_CHOICE_OPTIONS}
                 
                 onChange={handlers.onControlChange}
              />
              
           </div>
           
           <WizardStepButtonsBlock
              onPrevBtnClick={onPrevBtnClick}
              onNextBtnClick={onNextBtnClick}
              nextButtonAdditionalCssClass={`fixed-bottom2`}
           />


        </div>
    )
}